import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { UnitsOfMeasurement } from "../AltitudeRangeModifier";
import { CHANGE_LOWER_LIMIT_ACTION } from "./changeLowerLimit/changeLowerLimit.action";
import { changeLowerLimitPartialReducer } from "./changeLowerLimit/changeLowerLimit.reducer";
import { CHANGE_UPPER_LIMIT_ACTION } from "./changeUpperLimit/changeUpperLimit.action";
import { changeUpperLimitPartialReducer } from "./changeUpperLimit/changeUpperLimit.reducer";
import { CHANGE_UNITS_ACTION } from "./changeUnits/changeUnits.action";
import { changeUnitsPartialReducer } from "./changeUnits/changeUnits.reducer";

export interface AltitudeRangeState {
    lowerLimit: number;
    upperLimit: number;
    units: UnitsOfMeasurement;
}

export const altitudeRangeReducer = createReducer<AltitudeRangeState>(
    {
        lowerLimit: 0,
        upperLimit: 20000,
        units: UnitsOfMeasurement.METRE,
    },
    {
        [CHANGE_LOWER_LIMIT_ACTION]: changeLowerLimitPartialReducer,
        [CHANGE_UPPER_LIMIT_ACTION]: changeUpperLimitPartialReducer,
        [CHANGE_UNITS_ACTION]: changeUnitsPartialReducer,
    }
);
